"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// http://openlayers.org/en/v3.8.2/examples/drag-features.html
const ol = require("openlayers");
/**
 * @constructor
 * @extends {ol.interaction.Pointer}
 */
exports.Drag = function () {
    ol.interaction.Pointer.call(this, {
        handleDownEvent: exports.Drag.prototype.handleDownEvent,
        handleDragEvent: exports.Drag.prototype.handleDragEvent,
        handleMoveEvent: exports.Drag.prototype.handleMoveEvent,
        handleUpEvent: exports.Drag.prototype.handleUpEvent
    });
    /**
     * @type {ol.Pixel}
     * @private
     */
    this.coordinate_ = null;
    /**
     * @type {string|undefined}
     * @private
     */
    this.cursor_ = 'pointer';
    /**
     * @type {ol.Feature}
     * @private
     */
    this.feature_ = null;
    /**
     * @type {string|undefined}
     * @private
     */
    this.previousCursor_ = undefined;
};
ol.inherits(exports.Drag, ol.interaction.Pointer);
/**
 * @param {ol.MapBrowserEvent} evt Map browser event.
 * @return {boolean} `true` to start the drag sequence.
 */
exports.Drag.prototype.handleDownEvent = function (evt) {
    var map = evt.map;
    var feature = map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
        return feature;
    });
    if (feature) {
        this.coordinate_ = evt.coordinate;
        this.feature_ = feature;
    }
    return !!feature;
};
/**
 * @param {ol.MapBrowserEvent} evt Map browser event.
 */
exports.Drag.prototype.handleDragEvent = function (evt) {
    var map = evt.map;
    var feature = map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
        return feature;
    });
    var deltaX = evt.coordinate[0] - this.coordinate_[0];
    var deltaY = evt.coordinate[1] - this.coordinate_[1];
    var geometry = (this.feature_.getGeometry());
    geometry.translate(deltaX, deltaY);
    this.coordinate_[0] = evt.coordinate[0];
    this.coordinate_[1] = evt.coordinate[1];
};
/**
 * @param {ol.MapBrowserEvent} evt Event.
 */
exports.Drag.prototype.handleMoveEvent = function (evt) {
    if (this.cursor_) {
        var map = evt.map;
        var feature = map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
            return feature;
        });
        var element = evt.map.getTargetElement();
        if (feature) {
            if (element.style.cursor != this.cursor_) {
                this.previousCursor_ = element.style.cursor;
                element.style.cursor = this.cursor_;
            }
        }
        else if (this.previousCursor_ !== undefined) {
            element.style.cursor = this.previousCursor_;
            this.previousCursor_ = undefined;
        }
    }
};
/**
 * @param {ol.MapBrowserEvent} evt Map browser event.
 * @return {boolean} `false` to stop the drag sequence.
 */
exports.Drag.prototype.handleUpEvent = function (evt) {
    this.dispatchEvent({
        type: "moveend",
        feature: this.feature_
    });
    this.coordinate_ = null;
    this.feature_ = null;
    return false;
};



//////////////////
// WEBPACK FOOTER
// ./src/map/dragFeatures.ts
// module id = 310
// module chunks = 0